export default "__VITE_ASSET__d6a88fe0__"